module.exports = __webpack_public_path__ + "media/auth-bg.0c7cf3ba.mp4";